<ng-container *transloco="let t">
  @for (result of leading;track result.competitorId!) {
    @if(!filterGender || result.gender === filterGender) {
     <div class="ps-3"  @animate>
        <app-live-results-mobile-item [liveResult]="result" [hasBorderBottom]="false"/>
      </div>
    }
  }
  @for (result of competitorLiveResults;track result.competitorId!) {
    @if(!filterGender || result.gender === filterGender) {
    <div class="ps-3" @animate>
        <app-live-results-mobile-item [liveResult]="result" [hasBorderBottom]="false"/>
      </div>
      }
  }


  <div class="d-none d-lg-block">
  <div class="grid-table-box">
    <div class="grid-table">
      <ng-template [ngTemplateOutlet]="tableHeader"></ng-template>
      @for (liveResult of leading; track liveResult.competitorId!) {
      @if(!filterGender || liveResult.gender === filterGender) {
      <div class="grid-row">
        <div class="grid-cell bold" @animate>
          <div class="fw-semibold">{{ liveResult.rank ?? "" }}</div>
              </div>
              <div class="grid-cell bold"  @animate>
                <div class="fw-semibold">{{
                  ((liveResult?.firstName ?? "")| titlecase)
                  + " " + ((liveResult?.lastName ?? "") | titlecase)
                  }}
                </div>
              </div>
              <div class="grid-cell" @animate>{{ liveResult.startNumber ?? "" }}</div>
              <div class="grid-cell" @animate>{{ liveResult.totalTime | formatTime}}</div>
              <div class="grid-cell" @animate>{{ liveResult.category ?? "" }}</div>
              <div class="grid-cell" @animate>{{ liveResult.club ?? "" }}</div>
              <div class="grid-cell" @animate>{{ liveResult.gap }}</div>
              <div class="grid-cell" @animate>{{ liveResult.lapCount }}</div>
       </div>
      }
      }

      @for (liveResult of competitorLiveResults;let idx=$index;track liveResult.competitorId!) {
      @if(!filterGender || liveResult.gender === filterGender) {

      <div class="grid-row">
        <div class="grid-cell" @animate>
          <div class="fw-semibold">{{ liveResult.rank ?? "" }}</div>
                </div>
                <div class="grid-cell" @animate >
                  <div class="fw-semibold">
                    {{ ((liveResult?.firstName ?? "")| titlecase)
                  + " " +
                  ((liveResult?.lastName ?? "") | titlecase)
                    }}
                  </div>
                </div>
                <div class="grid-cell" @animate>{{ liveResult.startNumber ?? "" }}</div>
                <div class="grid-cell" @animate>{{ liveResult.totalTime | formatTime}}</div>
                <div class="grid-cell" @animate>{{ liveResult.category ?? "" }}</div>
                <div class="grid-cell" @animate>{{ liveResult.club ?? "" }}</div>
                <div class="grid-cell" @animate>{{ liveResult.gap }}</div>
                <div class="grid-cell" @animate>{{ liveResult.lapCount }}</div>
              </div>
          }
        }
    </div>
  </div>
  </div>

  <ng-template #tableHeader>
    <div class="grid-header">
      <div class="grid-cell">{{ t('live.results.events.results.table.rank') }}</div>
      <div class="grid-cell">{{t('app.common.name.surname') }}</div>
      <div class="grid-cell">{{ t('competitor.table.start.number')}}</div>
      <div class="grid-cell">{{ t('live.results.events.results.table.time') }}</div>
      <div class="grid-cell">{{ t('competitor.table.category')  }}</div>
      <div class="grid-cell">{{t('competitor.table.club.team')}}</div>
      <div class="grid-cell">{{t('live.results.events.results.table.gap')}}</div>
      <div class="grid-cell">{{ t('live.results.events.results.table.laps') }}</div>
    </div>
  </ng-template>
</ng-container>
